import {Component, Input, OnInit} from '@angular/core';
import {GrievanceService} from '../../_services/grievance.service';
import {ActivatedRoute} from '@angular/router';
import {HttpService} from '../../../common/_services/http.service';

@Component({
  selector: 'app-api-list',
  templateUrl: './api-list.component.html',
  styleUrls: ['./api-list.component.css']
})
export class ApiListComponent implements OnInit {
    @Input()
    caller_id: string;

    public ai_list_name = [];
    public API: any;
    public channel: any;

    color = 'primary';
    value = 50;
    is_spinner_visible = true;
    spinner_mode = 'indeterminate';
    api_obj = [];
  constructor(private grievanceService: GrievanceService, private httpService: HttpService,
    private route: ActivatedRoute) { }

  async ngOnInit() {
     this.route.queryParams.subscribe(params => {
            this.caller_id = params['msisdn'];
        });
     if (this.caller_id) {
         this.API = await this.httpService.getAPI(this.caller_id);
         this.api_obj = this.API.Items;
         if (this.api_obj.length > 0) {
             this.ai_list_name = JSON.parse(this.api_obj[0].ai_list).filter(function (value) {
                 return value.app_pkg_name;

             });
         }
         if (this.is_spinner_visible) {
             this.is_spinner_visible = false;
         }
     } else {
         this.api_obj.length = 0;
         this.is_spinner_visible = false;
     }
  }
}
